import type { TruckLocationHistoryRow } from '../TruckHistory'

export const sortTruckHistoryByTimestampAsc = (rows: TruckLocationHistoryRow[]): TruckLocationHistoryRow[] => {
    return [...rows].sort((a, b) => {
        const aTime = new Date(a.timestamp).getTime()
        const bTime = new Date(b.timestamp).getTime()
        if (isNaN(aTime) || isNaN(bTime)) return 0
        return aTime - bTime
    })
}
